import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from "@material-ui/core/MenuItem";

const StoresFilterForm =  (props) =>{
  const {filterStores, handleSubmit, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(filterStores)}>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="city" label={'City'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="enterSoftCode" label={'Entersoft Code'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="dwId" label={'Erp id'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="type" label={'Type'} component={RenderSelectField} fullWidth>
          <MenuItem value={'new'} >{'Νέα'}</MenuItem>
          <MenuItem value={'newComing'} >{'Υφιστάμενα'}</MenuItem>
          <MenuItem value={'old'} >{'Παλιά'}</MenuItem>
        </Field>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Filter'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'storesFilterForm',
})(StoresFilterForm);



// WEBPACK FOOTER //
// ./src/components/stores/storesFilterForm.js